import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AppUser} from "../../../../../framework/model/core/appuser/appuser";
import {OrderService} from "../../../../services/OrderService";
import {Events} from "../../../../../framework/providers/events";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {ModelClasses} from "../../../../model/modelClasses";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {PaymentPage} from "../../../cart/pages/payment/payment.page";
import {ItemProvider} from "../../../item/providers/item-provider/item-provider.service";
import {ApiTableComponent} from "../../../../../framework/components/list/api-table/api-table.component";
import {BusinessService} from "../../../../services/BusinessService";
import {ActivatedRoute} from "@angular/router";
import {ActionSheetController, LoadingController} from "@ionic/angular";
import {DomSanitizer} from "@angular/platform-browser";
import {Browser} from "@capacitor/browser";

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponent implements OnInit, OnDestroy {
    @Input()
    public modelId;
    @Input()
    public title: boolean = true;

    public appuser: AppUser;
    // public models: Array<AppUser> = [];
    public options: object = {};
    public tabs: object = {'value': null, "data": []};
    public filters;
    public companyData;

    public prefix: string = 'cartDetails_' + Math.floor(Math.random() * Math.floor(1000000));

    public initialized = false;
    public showLoading = false;
    public ready = false;
    public currentFiltersData = '';
    public modelOptions = {};
    public currentFilters = {};
    public currentTab = null;
    public inprogress = false;

    public subrowHtml = null;

    sort_field = '';
    search_txt = '';

    pdfUrl = null;
    loadingScreen;
    models = [];

    // public prefix: string = 'inv_' + Math.floor(Math.random() * Math.floor(1000000));

    constructor(public orderService: OrderService, public events: Events,
                public modelTools: ModelToolsProvider, private sanitizer: DomSanitizer,
                private loadingController: LoadingController,
                public actionSheetCtrl: ActionSheetController,
                public route: ActivatedRoute,
                public modelProvider: ModelProvider, public modelClasses: ModelClasses, public itemProvider: ItemProvider,
                public tools: ModelToolsProvider, public businessService: BusinessService) {
        this.appuser = this.orderService.getAppUser();
    }

    ngOnInit() {
        console.log("INVOICEE!!!")
        this.filters = this.currentFilters = {'company': this.modelId};

        this.route.queryParams.subscribe(params => {
            if (this.initialized) return;
            this.initialized = true;

            if (this.businessService.invoiceData) {
                this.tabs = this.businessService.invoiceData;

                if (params['tab']) {
                    for (let k in this.businessService.invoiceData['data']) {
                        if (this.businessService.invoiceData['data'][k]['value'] == params['tab']) {
                            this.currentTab = this.businessService.invoiceData['data'][k];
                            for (let k in this.currentTab['filters']) {
                                this.currentFilters[k] = this.currentTab['filters'][k];
                            }
                            this.currentFilters['open_tab_pdf'] = false;
                            this.ready = false;

                            if (this.currentTab) {
                                this.events.subscribe(this.prefix + '_modelUpdated', (data) => {
                                    this.ready = true;
                                });
                            }
                            break;
                        }
                    }
                    let tabfilters = JSON.parse(params['filters']);
                    for (let k in tabfilters) {
                        this.currentFilters[k] = tabfilters[k];
                        this.currentFiltersData = tabfilters[k];
                    }

                    if (tabfilters['sort']) {
                        this.sort_field = tabfilters['sort'];
                    }
                    if (tabfilters['search_txt']) {
                        this.search_txt = tabfilters['search_txt'];
                    }

                } else {
                    this.ready = true;
                }

            } else {
                this.modelProvider.custom('getInvoiceInterface', {
                    'setPrefix': false,
                    'company': this.modelId,
                    'mode': 'api_types'
                }).then((res) => {

                    this.ready = true;

                    if (res['res']) {
                        this.setInterfaceData(res);
                    } else {
                        this.setDefaultData();
                    }
                });
            }
        });

        // this.setTab(false);
    }

    ngOnDestroy() {
        if (this.currentTab) {
            this.events.unsubscribe(this.prefix + '_modelUpdated');
        }
    }

    setInterfaceData(res) {
        let models = res['models'];
        for (let modelData of models) {
            let cls = this.modelClasses.getClass(modelData['modelName']);
            let model = new cls({});
            let fields = modelData['fields'] ? modelData['fields'] : model.fields;
            let data = {
                'value': modelData['name'] ? modelData['name'] : modelData['modelName'],
                'model': model,
                'title': modelData['name'] ? modelData['name'] : modelData['modelName'],
                'checked': true,
                'modelName': modelData['modelName'],
                'display': 'table',
                'header': fields,
                'fields': fields,
                'field_tran': modelData['field_tran'],
                'field_data': modelData['field_data'],
                'calcable': modelData['calcable'],
                'model_key': modelData['model_key'],
                'checkedData': {'checked': {}, 'data': {}, 'balance': 0, 'amount': 0},
                'filters': modelData['filters'],
                'options': modelData['options'],
                'models': [],
                'prefix': this.tools.getRandomize()
            };
            this.tabs['data'].push(data);
            if (!this.tabs['value']) this.tabs['value'] = data['value'];
        }
        this.businessService.invoiceData = this.tabs;
        this.companyData = res['company_data']
    }

    setDefaultData() {
        this.tabs['value'] = 'checks';
        this.tabs['data'] = [
            {
                'value': 'checks',
                'title': 'checks',
                'checked': true,
                'modelName': 'bandObligoChecks',
                'display': 'table',
                'header': ['payDate', 'cardNum', 'qprice', 'currency'],
                'fields': ['payDate', 'cardNum', 'qprice', 'code'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'checksList'
            },
            {
                'value': 'openDebt',
                'title': 'openDebt',
                'checked': true,
                'modelName': 'bandObligoFncitems',
                'display': 'card',
                'fields': ['balDate', 'ivnum', 'fncPatname', 'details', 'price', 'fncDate'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'openDebtList'
            },
            {
                'value': 'withoutCharge',
                'title': 'withoutCharge',
                'checked': false,
                'modelName': 'bandObligoTrans',
                'display': 'table',
                'header': ['curDate', 'docno', 'price', 'currency'],
                'fields': ['curDate', 'docno', 'price', 'currencyCode'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'withoutChargetList'
            }
        ]
    }

    load_tab(totabId, model = null, field = null, event = null) {
        if (event) {
            event.stopPropagation();
        }
        if (this.currentTab && this.currentTab['field_data'] && this.currentTab['field_data'][field]) {

            //pdf
            if (model && this.currentTab['field_data'][field]['type'] == 'pdf') {
                const pdfUrl = model.data[field];
                window.open(pdfUrl, '_blank');
                return
            }

            if (model && this.currentTab['field_data'][field]['tabGo']) {
                let filters = {};
                if (this.currentTab && model && field) {
                    filters = {};//this.currentTab['filters'];
                    if (this.currentTab['field_data']) {
                        for (let k in model['data'][field + '_filter']) {
                            filters[k] = JSON.stringify(model['data'][field + '_filter'][k]);
                        }
                        totabId = this.currentTab['field_data'][field] ? this.currentTab['field_data'][field]['tab_id'] : null;
                    }
                }
                // this.tabs['value'] = tab['field_data'][field]['tab_id'];
                // this.ready = true;
                filters['sort'] = this.sort_field;
                filters['open_tab_pdf'] = false;

                this.modelTools.goTo('client-invoice/' + Math.floor(Math.random() * Math.floor(1000)),
                    {'filters': JSON.stringify(filters), 'tab': totabId});
                return;
            }
        } else if (model) {
            this.viewApiInvoiceTable(model);
        } else {
            let filters = {'sort': this.sort_field, 'search_txt': this.search_txt};
            this.modelTools.goTo('client-invoice/' + Math.floor(Math.random() * Math.floor(1000)),
                {'filters': JSON.stringify(filters), 'tab': totabId});
            return;
        }
    }

    setTab(tab) {
        return
        // this.ready = false;
        // if (model && field) {
        //     for (let k in model.data[field + '_filter']) {
        //         tab['filters'][k] = JSON.stringify(model.data[field + '_filter'][k]);
        //     }
        // }
        // if (event) {
        //     this.tabs['current_filter'] = event['detail']['filters'];
        // this.tabs['value'] = tabName;
        this.currentTab = tab;
        let me = this;
        me.ready = false;
        setTimeout(function () {
            me.ready = true;
        })
    }

    checkAll(tab, checkAllFlag) {
        for (let key in this.models) {
            let model = this.models[key];
            tab['checkedData']['checked'][model.data[tab['model_key']]] = checkAllFlag;
            if (checkAllFlag) {
                tab['checkedData']['data'][model.data[tab['model_key']]] = model
            }
        }
        this.setChecked(tab, null);
    }

    setChecked(tab, model) {
        let amount = 0;
        let toPay = 0;
        let toPay_ids = [];
        let checkedKeys = [];
        let balance = 0;
        let checked = tab['checkedData']['checked'];
        if (model) tab['checkedData']['data'][model.data[tab['model_key']]] = model;

        for (let key in checked) {
            let invoice = tab['checkedData']['data'][key];

            let invoice_balance = parseFloat(invoice.data[tab['calcable']]);
            if (checked[key]) {
                amount++;
                balance += invoice_balance;

                if (tab['options']['payment_allow'] && !invoice.data.paymentVerified) {
                    toPay += invoice_balance
                    toPay_ids.push(invoice.data.id)
                }

                toPay_ids.push(key)

            }
        }


        tab['checkedData']['amount'] = amount;
        tab['checkedData']['balance'] = balance;
        tab['checkedData']['toPay'] = toPay;
        tab['checkedData']['toPay_ids'] = toPay_ids;
        tab['checkedData']['checkedKeys'] = toPay_ids.join(',');
        console.log(tab)
    }

    refresh(prefix) {
        this.events.publish(prefix + '_updateFilter', {'refresh': true});
    }

    setModel(model, tab) {
        let options = tab['options']
        console.log(model)
        console.log(options)
        console.log(tab)

        if (model.data['order']) {
            this.tools.goTo('order/' + model.data['order'])
            return;
        }

        if (!options['onclick'])
            return

        if (model.data.item && options['onclick']['page'] == 'item/') {
            let item = this.itemProvider.getItemById(model.data.item);
            this.itemProvider.openItem(item);
            return;
        }

        if (options['onclick']['url_callback']) {
            let me = this;
            this.tools.yesOrNoAlert(function () {
                me.modelProvider.customPost(options['onclick']['url_callback'], {'modelId': model.data[options['onclick']['modelKey']],}, {'setPrefix': true}).then((res) => {
                    me.modelProvider.presentToast(me.tools.getTranslate(res['data']['res']), true, res['data']['color']);
                    me.events.publish(tab['prefix'] + '_updateModels', tab['filters']);
                })
            })
        }
    }

    viewApiInvoiceTable(model, tab = null) {
        if (model && model['data']['noclick']) {
            console.log('no click.');
            return;
        }

        console.log("tab:");
        console.log(tab);

        let filters = model.data['filters'] || model.data;
        filters['setPrefix'] = true;
        if (tab['filters']['subrow_html']) {
            this.pdf_click(filters);
        } else {
            this.presentLoading();
            this.modelProvider.custom('apiInvoiceDetails', filters).then((res: any) => {
                this.tools.showModal(ApiTableComponent, res, 'animated-popover full-size-modal');
                this.loadingScreen.dismiss();
            })
        }

    }

    open_tab_pdf(tab) {
        let filters = tab['filters'];
        filters['setPrefix'] = true;
        filters['open_tab_pdf'] = true;
        filters['totabId'] = tab['filters']['docType'];
        this.pdf_click(filters);
    }


    // open menu and than continue
    async pdf_click(filters) {
        this.inprogress = true;
        // header: '',
        const actionSheet = await this.actionSheetCtrl.create({
            buttons: [
                {
                    text: this.tools.getTranslate('Popup Rows'),
                    icon: 'document-outline',   // <-- icon
                    handler: () => this.openPdf(filters, false, true)
                },
                {
                    text: this.tools.getTranslate('Open PDF'),
                    icon: 'document-outline',   // <-- icon
                    handler: () => this.openPdf(filters)
                },
                {
                    text: this.tools.getTranslate('Share Whatsapp'),
                    icon: 'share-outline',      // <-- icon
                    handler: () => this.openPdf(filters, true)
                },
                {
                    text: this.tools.getTranslate('cancel'),
                    icon: 'close',
                    role: 'cancel',
                    handler: () => {
                        this.inprogress = true;
                    }
                }
            ]
        });

        await actionSheet.present();
    }

    // load pdf from server and show it.
    openPdf(filters, share = false, showRows = false) {
        if (showRows) {
            this.presentLoading();
            this.modelProvider.custom('apiInvoiceDetails', filters).then((res: any) => {
                this.tools.showModal(ApiTableComponent, res, 'animated-popover full-size-modal');
                this.loadingScreen.dismiss();
            })
        } else if (filters['open_tab_pdf']) {
            // tab details
            filters['offset'] = 0;
            filters['limit'] = 20;
            filters['sort'] = this.sort_field;
            filters['search_txt'] = this.search_txt;
            // this.modelTools.goTo('client-invoice/' + Math.floor(Math.random() * Math.floor(1000)),
            //     {'filters': JSON.stringify(filters), 'tab': filters['totabId']});

            this.presentLoading();
            this.modelProvider.custom('apiInvoice', filters).then((res: any) => {
                this.inprogress = false;

                this.loadingScreen.dismiss();
                this.show_pdf(res['file_url'], share);
            })

        } else {
            // row details
            this.presentLoading();
            let me = this;
            this.modelProvider.custom('apiInvoiceDetails', filters).then((res: any) => {
                this.loadingScreen.dismiss();
                this.inprogress = false;

                if (!res['file_url']) {
                    this.tools.textAlert(me.tools.getTranslate('no data found!'));
                    return;
                }

                // const pdfUrl = URL.createObjectURL(res);
                // window.open(pdfUrl, '_blank');
                // const blob = new Blob([res], {type: 'application/pdf'});
                this.show_pdf(res['file_url'], share);
            });
        }
    }

    async show_pdf(file_url, share) {
            console.log("1111 url::::")
        if (share) {
            let pdfUrl = file_url;
            let send_text = 'הודעה חדשה מ' + `${this.appuser.data.name}`;
            send_text += ' באפליקציה של ' + `${this.businessService.getGlobalSettings().data.title}`;
            const message = encodeURIComponent(`${send_text}: ${pdfUrl}`);
            const whatsappUrl = `https://wa.me/?text=${message}`;
            window.open(whatsappUrl, '_blank');
        } else {
            console.log("url::::")
            console.log(file_url)
            // this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(file_url);//this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
            await Browser.open({ url: file_url });
        }

    }

    async presentLoading() {
        this.loadingScreen = await this.loadingController.create({
            message: 'אנה המתן..',
            spinner: 'crescent', // or 'bubbles', 'dots', etc.
            backdropDismiss: false, // prevent user from dismissing
            cssClass: 'full-screen-loading'
        });
        await this.loadingScreen.present();
    }

    sort(tab, field, event) {
        this.sort_field = this.sort_field == field ? '-' + field : field;
        this.load_tab(this.currentTab['value']);
    }

    search(tab) {
        this.load_tab(this.currentTab['value']);
    }

    payInvoice(tab) {
        let prefix = 'invoice_new_payment_' + this.tools.getRandomize();
        this.tools.showModal(PaymentPage, {
            'params': {'invoices': tab['checkedData']['toPay_ids'].join(','), 'prefix': prefix}
        })

        this.events.subscribe(prefix, (res) => {
            Object.keys(tab['checkedData']['checked']).forEach(key => {
                delete tab['checkedData']['checked'][key];
            })

            tab['checkedData']['amount'] = 0;
            tab['checkedData']['balance'] = 0;
            tab['checkedData']['toPay'] = 0;
            tab['checkedData']['toPay_ids'] = [];


            this.events.publish(tab['prefix'] + '_updateModels');
            this.events.unsubscribe(prefix);
        })

    }

    extLink(url) {
        window.open(url, '_blank');
    }

}
